import Image from 'next/image'

interface IProps {
  altTag: string
  imageSrc: string
}

export const ShareIcons = ({ altTag, imageSrc }: IProps) => {
  return (
    <div className="md:pr-[15.6px] px-[7px] md:px-0">
      <Image src={imageSrc} alt={altTag} width={18} height={18} />
    </div>
  )
}

export default ShareIcons
